/**
 * 高德原生组件
 * zxw
 * 2024-09-04
 */
import * as ReactDOM from 'react-dom/client';
import { useEffect, useState } from 'react';
import $ from 'jquery';
import AMapLoader from '@amap/amap-jsapi-loader';
import CNF from '../../incs/Config';
import { UjoinParams, AddRequestHeaders} from '../../incs/FunHelper';
import { Button, Input, message } from 'antd';
import {
    SearchOutlined,
    AimOutlined,
} from '@ant-design/icons';

import TRA from '../../images/traffic-right-aim.svg';
import WWA from '../../images/walkway-aim.svg';

//  自定义icon
import TRIcon from '../icons/TRIcon';
import WalkwayIcon from '../icons/WalkwayIcon';

import MainImagePreview from '../intersections/MainImagePreview';
import WalkwayImagePreview from '../intersections/WalkwayImagePreview';

var rootImage = null;

const AMapLineEditer = () => {
    const [aMap, setAMap] = useState(null);
    const [map, setMap] = useState(null);
    const [intersectionLL, setIntersectionLL] = useState(null);         //  路口图层
    const [showIntersectionLL, setShowIntersectionLL] = useState(1);    //  路口图层是否显示
    const [walkwayLL, setWalkwayLL] = useState(null);                   //  行人过街图层
    const [showWalkwayLL, setShowWalkwayLL] = useState(1);              //  行人过街图层是否显示
    const [searchOpen, setSearchOpen] = useState(0);
    const [intersectionName, setIntersectionName] = useState('');
    const [intersectionFullname, setIntersectionFullname] = useState('');
    const [isShowLnglat, setIsShowLnglat] = useState(0);                        //  是否显示经纬达
    const [lnglat, setLnglat] = useState('');                                   //  经纬度
    const [polylineArr, setPolylineArr] = useState([]);                         //  路线数组
    const [polylineEditor, setPolylineEditor] = useState(null);                 //  编辑划线实体
    const [currentPolylineNumber, setCurrentPolylineNumber] = useState(0);      //  当前路线编码
    // const [path, setPaht] = useState([]);

    /**
     * 鼠标移入路口图片显示弹框
     * @param {*} item 
     * @returns 
     */
    const intersectionMarkerContent = (item) => {
        let isNetwork = item.host_machine_is_networking?
        '<span class="span-green">是</span>':'<span class="span-red">否</span>';
        return '<div class="amap-info-window">'
            + '<h4>路口信息</h4>'
            + '<p>路口名称：' + item.name + '</p>'
            + '<p>路口编码：' + item.number + '</p>'
            + '<p>路口类型：' + item.type + '</p>'
            + '<p>放行方式：' + item.structure + '</p>'
            + '<p>主机品牌：' + item.host_machine_model + '</p>'
            + '<p>网络厂商：' + item.operator + '</p>'
            + '<p>是否联络：' + isNetwork + '</p>'
            + '<p>建设年份：' + item.create_year + '</p>'
            + '<div class="amap-info-sharp"></div>'
        + '</div>'
    }

    /**
     * 鼠标移入行人过街显示弹框
     * @param {*} item 
     * @returns 
     */
    const walkwayMarkerContent = (item) => {
        return '<div class="amap-info-window">'
            + '<h4>行人过街</h4>'
            + '<p>名称：' + item.name + '</p>'
            + '<p>编码：' + item.number + '</p>'
            + '<p>主机：' + item.host_machine + '</p>'
            + '<p>主机型号：' + item.host_machine_model + '</p>'
            + '<p>建设年份：' + item.create_year + '年</p>'
            + '<div class="amap-info-walkway"></div>'
        + '</div>'
    }

    /**
     * 获取区域坐标
     * @param {*} url   geojson格式数据
     * @param {*} map   map实例对象
     * @param {*} AMap  AMap实例对象
     */
    const getGEOJson = (url,map,AMap) => {
        fetch(url)
        .then((response) => response.json())
        .then((data) => {
            let path = data.features[0].geometry.coordinates[0][0];
            //  创建多边形 Polygon 实例
            var polygon = new AMap.Polygon({
                path: path,             //  路径
                fillColor: '#045263',   //  多边形填充颜色
                strokeWeight: 2,        //  线条宽度，默认为 2
                strokeColor: '#04C0C2', //  线条颜色
                cursor: 'pointer',
                // strokeOpacity: 0.9,
            });
            //  鼠标移入事件
            polygon.on('mouseover', () => {
                polygon.setOptions({//  修改多边形属性的方法
                    strokeColor: '#3284F7',
                });
            });
            //  鼠标移出事件
            polygon.on('mouseout', () => {
                polygon.setOptions({//  修改多边形属性的方法
                    strokeColor: '#04C0C2',
                });
            });
            //  鼠标点击事件
            polygon.on('click', () => {
                polygon.setOptions({//  修改多边形属性的方法
                    strokeColor: '#FF904D',
                });
            });
            //  鼠标移动事件
            polygon.on('mousemove',function(e){
                //  获取鼠标选择点经纬度
                if(e.lnglat){
                    let lnglat = e.lnglat.lng + ',' + e.lnglat.lat
                    setLnglat(lnglat);
                }
            });
            //  多边形 Polygon对象添加到 Map
            map.add(polygon);
            //  将覆盖物调整到合适视野
            map.setFitView([polygon]);
    });
    }

    /**
     * 获取红绿灯路口，并添加文本图层
     * @param {*} map   map实例对象
     * @param {*} AMap  AMap实例对象
     */
    const getIntersections = (map,AMap) => {
        //  获取红绿灯标点
        const intersectionLL = new AMap.LabelsLayer({
            zooms: [2, 20],
            zIndex: 1000,
            collision: true,        //  该层内标注是否避让
            allowCollision: true,   //  不同标注层之间是否避让  
        });
        const icon = {
            type: 'svg',
            size: [16, 37],
            image: TRA,
            anchor: 'center',
        };
        var params = {
            'name':intersectionName,
            'full_name':intersectionFullname,
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}intersections${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    let initData = data.dat;
                    if(initData.length > 0){
                        let labelMarkerArr = [];
                        // 普通点
                        var normalMarker = new AMap.Marker({
                            anchor: 'bottom-center',
                            offset: [0, -30],
                        });
                        for(let i=0; i<initData.length; i++){
                            let item = initData[i];
                            if(item.longitude && item.latitude){
                                let position = [];
                                position.push(item.longitude);
                                position.push(item.latitude);
                                let LM = {
                                    position: position,
                                    zIndex: 16,
                                    rank: 1,        // 避让优先级
                                    icon: icon,
                                }
                                const labelMarker = new AMap.LabelMarker(LM);
                                labelMarker.on('mouseover',function(e){
                                    //  鼠标移入
                                    var position = e.data.data && e.data.data.position;
                                    if(position){
                                        normalMarker.setContent(intersectionMarkerContent(item));
                                        normalMarker.setPosition(position);
                                        map.add(normalMarker);
                                    }
                                });
                                labelMarker.on('mouseout',function(){
                                    //  鼠标移出
                                    map.remove(normalMarker);
                                });
                                labelMarker.on('click', function(){
                                    //  鼠标点击
                                    const params = {
                                        'intersection_ulid': item.key,
                                        'is_main': 1,
                                        'page_size': 1,
                                        'current_index': 1
                                    };
                                    $.ajax({
                                        url: `${CNF.api}intersection/images${UjoinParams(params)}`,
                                        headers: AddRequestHeaders(),
                                        type: 'GET',success:function(data){
                                            if(data.res === 0){
                                                if(data.dat.length > 0){
                                                    if(!rootImage){
                                                        rootImage = ReactDOM.createRoot(document.getElementById('show-image-id'));
                                                    }
                                                    rootImage.render(
                                                    <MainImagePreview
                                                        open={true}
                                                        record={data.dat[0]}
                                                    />);
                                                }
                                            }
                                        }
                                    });
                                })
                                labelMarkerArr.push(labelMarker);
                            }
                            
                        }
                        intersectionLL.add(labelMarkerArr);
                    }else{
                        //
                    }
                }
            }
        });
        map.add(intersectionLL);
        setIntersectionLL(intersectionLL);
    }

    /**
     * 获取行人过街，并添加文本图层
     * @param {*} map   map实例对象
     * @param {*} AMap  AMap实例对象
     */
    const getWalkways = (map, AMap) => {
        //  获取红绿灯标点
        const walkwayLL = new AMap.LabelsLayer({
            zooms: [2, 20],
            zIndex: 1001,
            collision: true,        //  该层内标注是否避让
            allowCollision: true,   //  不同标注层之间是否避让  
        });
        const icon = {
            type: 'svg',
            size: [24, 24],
            image: WWA,
            anchor: 'center',
        };
        var params = {
            // 'name':intersectionName,
            // 'full_name':intersectionFullname,
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}walkways${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    let initData = data.dat;
                    if(initData.length > 0){
                        let labelMarkerArr = [];
                        // 普通点
                        var normalMarker = new AMap.Marker({
                            anchor: 'bottom-center',
                            offset: [0, -30],
                        });
                        for(let i=0; i<initData.length; i++){
                            let item = initData[i];
                            if(item.longitude && item.latitude){
                                let position = [];
                                position.push(item.longitude);
                                position.push(item.latitude);
                                let LM = {
                                    position: position,
                                    zIndex: 16,
                                    rank: 1,        // 避让优先级
                                    icon: icon,
                                }
                                const labelMarker = new AMap.LabelMarker(LM);
                                labelMarker.on('mouseover',function(e){
                                    //  鼠标移入
                                    var position = e.data.data && e.data.data.position;
                                    if(position){
                                        normalMarker.setContent(walkwayMarkerContent(item));
                                        normalMarker.setPosition(position);
                                        map.add(normalMarker);
                                    }
                                });
                                labelMarker.on('mouseout',function(){
                                    //  鼠标移出
                                    map.remove(normalMarker);
                                });
                                labelMarker.on('click', function(){
                                    //  鼠标点击
                                    const params = {
                                        'walkway_ulid': item.key,
                                        'page_size': 1,
                                        'current_index': 1
                                    };
                                    $.ajax({
                                        url: `${CNF.api}walkway/images${UjoinParams(params)}`,
                                        headers: AddRequestHeaders(),
                                        type: 'GET',success:function(data){
                                            if(data.res === 0){
                                                if(data.dat.length > 0){
                                                    if(!rootImage){
                                                        rootImage = ReactDOM.createRoot(document.getElementById('show-image-id'));
                                                    }
                                                    rootImage.render(
                                                    <WalkwayImagePreview
                                                        open={true}
                                                        record={data.dat[0]}
                                                    />);
                                                }
                                            }
                                        }
                                    });
                                })
                                labelMarkerArr.push(labelMarker);
                            }
                            
                        }
                        walkwayLL.add(labelMarkerArr);
                    }else{
                        //
                    }
                }
            }
        });
        map.add(walkwayLL);
        setWalkwayLL(walkwayLL);
    }

    /**
     * 绘制线路起始标签
     * @param {*} map 
     * @param {*} AMap 
     * @param {*} polylineEditor 
     * @param {*} polylineArr 
     */
    const startLineMarker = (map, AMap, polylineEditor,polylineArr) => {
        for(let i=0;i<polylineArr.length;i++){
            let item = polylineArr[i];
            let text = new AMap.Text({
                text: item.number,      //   标记显示的文本内容
                anchor: 'center',       //   设置文本标记锚点位置
                draggable: true,        //  是否可拖拽
                cursor: 'pointer',      //  指定鼠标悬停时的鼠标样式。
                angle: 0,               //  点标记的旋转角度
                style: {
                //   'padding': '.75rem 1.25rem',
                //   'margin-bottom': '1rem',
                    'border': '2px solid #fff',
                    'border-radius': '22px',
                    'background-color': '#1577FF',
                    'width': '22px',
                    'height': '22px',
                    // 'border-width': 0,
                //   'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
                    'text-align': 'center',
                    'font-size': '12px',
                    'color': '#fff',
                },
                position: item.$x[0][0],    //  点标记在地图上显示的位置
              });
            text.setMap(map);               //  将文本标记设置到地图上
            text.on('click', function(){    //  切换路线
                polylineEditor.setTarget(item);
                polylineEditor.open();
                setCurrentPolylineNumber(item.number);
            });
        }
    }

    /**
     * 绘制路线
     * @param {*} map 
     * @param {*} AMap 
     */
    const lineEditer = (map, AMap) => {
        var params = {
            'status': CNF.status[0].value,
            'page_size': CNF.pageSize,
            'current_index': 1
        };

        //  获取线路信息
        $.ajax({
            url: `${CNF.api}lines${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    let polylineEditor = null;
                    //  线路数组
                    let plArr = [];
                    if(data.dat.length > 0){
                        //  绘制线路
                        for(let i=0; i<data.dat.length; i++){
                            let item = data.dat[i];
                            let polyline = new AMap.Polyline({
                                path: JSON.parse(item.path),
                                showDir: true,
                                strokeColor: '#FF33FF',    //   线颜色
                                strokeOpacity: 1,          //   线透明度
                                strokeWeight: 6,           //   线宽
                                strokeStyle: 'solid',      //   线样式
                                lineJoin: 'round',         //   折线拐点连接处样式
                                // isOutline: true,           //   显示描边
                                // outlineColor: '#FF904D',   //   描边颜色
                                bubble: true,
                                zIndex: 999,
                            })
                            polyline.key = item.key;
                            polyline.number = item.number;
                            polyline.name = item.name;
                            plArr.push(polyline);
                        }
                        map.add(plArr);
                        setPolylineArr(plArr);                      //  加入路线数组
                        //  缩放地图到合适的视野级别
                        map.setFitView();
                        //  默认选择第一条线路
                        polylineEditor = new AMap.PolylineEditor(map, plArr[0]);
                        polylineEditor.setTarget(plArr[0]);
                        polylineEditor.open();
                        setCurrentPolylineNumber(plArr[0].number);
                        startLineMarker(map,AMap,polylineEditor,plArr);
                    }else{
                        //  实例化折线编辑器，传入地图实例和要进行编辑的折线实例
                        polylineEditor = new AMap.PolylineEditor(map, null);
                    }
                    //  缩放地图到合适的视野级别
                    map.setFitView();
                    polylineEditor.on('add', function (e) {
                        //  新增线路
                        e.target.setOptions({
                            showDir: true,
                            // strokeColor: '#FF33FF',    //   线颜色
                            strokeOpacity: 1,          //   线透明度
                            strokeWeight: 6,           //   线宽
                            strokeStyle: 'solid',      //   线样式
                            lineJoin: 'round',         //   折线拐点连接处样式
                            // isOutline: true,           //   显示描边
                            // outlineColor: '#FF904D',   //   描边颜色
                            bubble: true,
                            zIndex: 999,
                        });
                        if(typeof polylineArr === 'object' && Array.isArray(polylineArr)){
                            //  解决延迟更新，默认赋值已绘制的路线
                            let ps = polylineArr.length>0?polylineArr:plArr;
                            //  追加路线
                            let pl = e.target;
                            pl.key = '';
                            pl.number = ps.length + 1;
                            pl.name = pl.number + '号线路';
                            ps.push(pl);
                            setCurrentPolylineNumber(pl.number);     //  当前路线编码
                            setPolylineArr(ps);                      //  更新路线数组
                        }
                    });
                    setPolylineEditor(polylineEditor);               //  线路编辑实体    
                }
            }
        })
    }

    /**
     * 新增线路
     * @param {*} polyline 
     */
    const create = (polyline) =>{
        //  执行创建
        $.ajax({
            url: `${CNF.api}lines`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data:JSON.stringify({
                'name': polyline.name,
                'number': polyline.number,
                'path': polyline.$x[0],
                'description': '',
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        });
    };

    /**
     * 修改线路
     * @param {*} polyline 
     */
    const update = (polyline) =>{
        //  执行更新
        $.ajax({
            url: `${CNF.api}lines/${polyline.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data:JSON.stringify({
                'action': 'UPDATE',
                'name': polyline.name,
                'number': polyline.number,
                'path': polyline.$x[0],
                'description': '',
            }),success:function(data){
                if(data.res === 0){
                    message.success(data.msg, 1);
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        });
    };

    /**
     * 保存路线
     * @returns 
     */
    const savePolyline = () => {
        if(currentPolylineNumber > 0){
            //  判断是新增还是修改
            let polyline = polylineArr[currentPolylineNumber - 1];
            if(polyline.key){
                //  修改
                update(polyline);
            }else{
                //  新增
                create(polyline);
                //  更新路线编号
                startLineMarker(map,aMap,polylineEditor,polylineArr);
            }
        }else{
            return;
        }
    }

    useEffect(()=>{
        window._AMapSecurityConfig = {
            securityJsCode: 'ceea76ab9503e286229776114f3a1cbd',
        };

        var params = {
            'page_size': 1,
            'current_index': 1
        };
        //  获取组织区域信息
        $.ajax({
            url: `${CNF.api}setting/areas${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        let item = data.dat[0];
                        let center = [];
                        //  设置中心点经纬度
                        center.push(item.longitude);
                        center.push(item.latitude);
                        AMapLoader.load({
                            key:'e43074060ab1913e75577155b646d10e',       //   申请好的Web端开发者Key，首次调用 load 时必填
                            version: '2.0',                               //   指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                            plugins: [
                                'AMap.MoveAnimation',
                                'AMap.PolylineEditor',
                            ],                                            //   需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
                        }).then((AMap)=>{
                            setAMap(AMap);
                            let map = new AMap.Map('a-map-container',{    //   设置地图容器id
                                center: center,                           //   初始化地图中心点位置
                                mapStyle: 'amap://styles/blue',
                                zoom: 13,
                            });

                            //  鼠标移动事件
                            map.on('mousemove',function(e){
                                //  获取鼠标选择点经纬度
                                if(e.lnglat){
                                    let lnglat = e.lnglat.lng + ',' + e.lnglat.lat
                                    setLnglat(lnglat);
                                }
                            });

                            map.on('complete', function(){
                                //   添加插件
                                getIntersections(map,AMap); 
                                getWalkways(map,AMap);
                                lineEditer(map,AMap,center);
                                setMap(map);    
                            });
                        }).catch(e=>{
                            console.log(e);
                        })
                    }
                }
            }
        })
    },[]);

    useEffect(()=>{
        if(map && aMap){
            //  移除现有图层
            map.remove(intersectionLL);
            getIntersections(map,aMap);
        }
    },[intersectionFullname,intersectionName]);

    return <>
        <div style={{ position: 'relative',height: '100%',width: '100%' }}>
            <div id='a-map-container' style={{ height: '100%',width: '100%' }} ></div>
            <div style={{ position: 'absolute', top: 0, left: 0, paddingTop: 8,paddingLeft: 8,}}>
                <Button style={{ 
                    background:'#020F3A',
                    border:'1px solid #020F3A',
                    opacity: 1, 
                    borderRadius: 3, 
                    color: '#04C0C2', 
                    fontSize: 20, 
                    fontWeight: 400,
                }} onClick={() => {setSearchOpen(searchOpen===2?0:searchOpen+1);}} icon={<SearchOutlined />} /> 
                <div style={{ float: 'right',marginLeft: 5, display: searchOpen ? 'block' : 'none' }}>
                    {
                        searchOpen&&searchOpen===1?<Input style={{ 
                            height: 30, 
                            border: 0, 
                            borderRadius: 3,
                            opacity: 0.5,
                            fontSize: 13,
                            // color: '#04C0C2', 
                        }} 
                            placeholder='路口名称'
                            value={intersectionName}
                            onChange={(e) => {setIntersectionName(e.target.value);}}
                        />:''
                    }
                    {
                        searchOpen&&searchOpen===2?<Input style={{ 
                            height: 30, 
                            border: 0, 
                            borderRadius: 3,
                            opacity: 0.5,
                            fontSize: 13,
                            // color: '#04C0C2', 
                        }} 
                            placeholder='路口全称'
                            value={intersectionFullname}
                            onChange={(e) => {setIntersectionFullname(e.target.value);}}
                        />:''
                    }
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 20, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        if(showIntersectionLL){
                            map.remove(intersectionLL);    //  移除图层
                        }else{
                            map.add(intersectionLL);       //  添加图层
                        }
                        setShowIntersectionLL(showIntersectionLL?0:1);
                        
                    }} icon={<TRIcon />} /> 
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 20, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        if(showWalkwayLL){
                            map.remove(walkwayLL);    //  移除图层
                        }else{
                            map.add(walkwayLL);       //  添加图层
                        }
                        setShowWalkwayLL(showWalkwayLL?0:1);
                        
                    }} icon={<WalkwayIcon style={{ color: '#04C0C2'}} />} /> 
                </div>
                <div>
                    <Button style={{ 
                        background:'#020F3A',
                        border:'1px solid #020F3A',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 20, 
                        fontWeight: 400,
                        marginTop: 8,
                    }} onClick={() => {
                        setIsShowLnglat(isShowLnglat?0:1);
                        
                    }} icon={<AimOutlined />} /> 
                </div>
                <div style={{ borderRadius: 3,marginTop: 8,background: '#fff',padding:'3px 5px' }}>
                    {
                        polylineArr&&polylineArr.length>0&&polylineArr.map((item)=>{
                            return <Button key={item.number} style={{ 
                                // background:'#020F3A',
                                border:'1px solid #04C0C2',
                                opacity: 1, 
                                borderRadius: 3, 
                                color: '#04C0C2', 
                                fontSize: 12, 
                                padding: '0 8px',
                                type:'link',
                                display: 'block',
                                marginTop: 3,
                                width: '100%',
                                // fontWeight: 400,
                                
                            }} onClick={() => {
                                polylineEditor.setTarget(item);
                                polylineEditor.open();
                                setCurrentPolylineNumber(item.number);
                            }}>{item.name}</Button>
                        })
                    }
                    
                    <Button style={{ 
                        // background:'#020F3A',
                        border:'1px solid #04C0C2',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 12, 
                        padding: '0 8px',
                        type:'link',
                        display: 'block',
                        marginTop: polylineArr.length>0?3:0,
                        // fontWeight: 400,
                        
                    }} onClick={() => {
                        polylineEditor.setTarget();
                        polylineEditor.open();
                    }}>新增线路</Button>
                    <Button style={{ 
                        // background:'#020F3A',
                        border:'1px solid #04C0C2',
                        opacity: 1, 
                        borderRadius: 3, 
                        color: '#04C0C2', 
                        fontSize: 12, 
                        padding: '0 8px',
                        type:'link',
                        marginTop: 3,
                        // fontWeight: 400,
                        
                    }} onClick={() => {
                        polylineEditor.close();
                        savePolyline();
                    }}>保存线路</Button>
                </div>
            </div>
            <div style={{ position: 'absolute', bottom: 20, left: 0, paddingTop: 8,paddingLeft: 8,}}>
                {
                    isShowLnglat&&lnglat?<div style={{ fontSize: 12,padding: '2px 5px', background:'#fff',borderRadius: 3}}>{lnglat}</div>:''
                }
            </div>
        </div>
        <div id='show-image-id'></div>
    </>
}

export default AMapLineEditer;